import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800">
      {/* Disclaimer */}
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="flex items-start gap-3 p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
          <Shield className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-zinc-500 leading-relaxed">
            <span className="text-zinc-400 font-medium">Avertissement :</span> Assistant by Léon fournit une analyse automatisée d'aide à la décision, à titre informatif et indicatif. Les résultats proposés ne constituent ni un diagnostic technique exhaustif, ni une mission de maîtrise d'œuvre, ni un contrôle de conformité sur site, ni un avis juridique. L'utilisateur reste seul responsable de ses décisions, signatures, paiements et choix d'entreprise.
          </p>
        </div>
      </div>

      {/* Footer Links */}
      <div className="max-w-6xl mx-auto px-6 py-6 border-t border-zinc-800">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <span className="text-gold-500 font-heading font-bold">Assistant by Léon</span>
            <span className="text-zinc-500 text-xs ml-2">Un produit de l'écosystème Phénix</span>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link 
              to="/conditions-generales" 
              className="text-zinc-500 hover:text-gold-500 transition-colors"
            >
              CGU/CGV
            </Link>
            <Link 
              to="/legal" 
              className="text-zinc-500 hover:text-gold-500 transition-colors"
            >
              Mentions et limites du service
            </Link>
            <a 
              href="mailto:contact@phenix-inspect.fr" 
              className="text-zinc-500 hover:text-gold-500 transition-colors"
            >
              Contact
            </a>
          </div>
          
          <p className="text-zinc-600 text-sm">
            © {new Date().getFullYear()} Assistant by Léon. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
